import { Api } from '../api/Api.js'

export async function apiStoreUpdateBankInformation(body) {
  return await Api(
    'post',
    '/bank_information/store_or_update_bank_information',
    { body }
  )
}
